import { z } from 'zod';

const choiceSchema = z.object({
  id: z.string().optional(),
  ref: z.string().optional(),
  label: z.string().optional(),
});

const fieldSchema = z.object({
  id: z.string().optional(),
  ref: z.string().optional(),
  type: z.string().optional(),
  title: z.string().optional(),
  properties: z.object({}).optional(),
  choices: z.array(choiceSchema).optional(),
});

const definitionSchema = z
  .object({
    id: z.string().optional(),
    title: z.string().optional(),
    fields: z.array(fieldSchema).optional(),
    endings: z
      .array(
        z
          .object({
            id: z.string().optional(),
            ref: z.string().optional(),
            title: z.string().optional(),
            type: z.string().optional(),
            properties: z
              .object({
                show_button: z.boolean().optional(),
                share_icons: z.boolean().optional(),
              })
              .optional(),
          })
          .partial(),
      )
      .optional(),
  })
  .partial();

const answerSchema = z
  .object({
    type: z.string().optional(),
    choice: choiceSchema.optional(),
    text: z.string().optional(),
    field: z
      .object({
        id: z.string().optional(),
        type: z.string().optional(),
        ref: z.string().optional(),
      })
      .partial(),
  })
  .partial();

const formResponseSchema = z
  .object({
    form_id: z.string().optional(),
    token: z.string().optional(),
    landed_at: z.string().optional(),
    submitted_at: z.string().optional(),
    hidden: z
      .object({
        email: z.string().optional(),
        name: z.string().optional(),
        user_id: z.string().optional(),
        device_info: z.string().optional(),
        visitor_id: z.string().optional(),
        product_id: z.string().optional(),
      })
      .partial(),
    definition: definitionSchema.optional(),
    answers: z.array(answerSchema).optional(),
    ending: z
      .object({
        id: z.string().optional(),
        ref: z.string().optional(),
      })
      .optional(),
  })
  .partial();

export const TypeformEvent = z
  .object({
    event_id: z.string().optional(),
    event_type: z.string().optional(),
    form_response: formResponseSchema.optional(),
  })
  .partial();

export type TypeformEvent = z.infer<typeof TypeformEvent>;
